/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { CONFIRM_RESPONDENT,CONFIRM_RESPONDENT_RESPONSE } = constants.ConfirmRespondentConstants;

export default {
    CONFIRM_RESPONDENT,
    CONFIRM_RESPONDENT_RESPONSE,

  requestConfirmRespondent: payload => ({
    type: CONFIRM_RESPONDENT,
    payload
  }),
  confirmRespondentReceived: () => ({
    type: CONFIRM_RESPONDENT_RESPONSE
  }),
};
